import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Manifesto } from "@/components/landing/Manifesto";
import { Experience } from "@/components/landing/Experience";
import { SocialFeed } from "@/components/landing/SocialFeed";
import { NextChapter } from "@/components/landing/NextChapter";
import { RegistrationSection } from "@/components/landing/RegistrationSection";
import { Footer } from "@/components/landing/Footer";

export default function LandingPage() {
  const [availability, setAvailability] = useState(null);

  const loadAvailability = useCallback(async () => {
    try {
      const { data } = await api.get("/registrations/availability");
      setAvailability(data);
    } catch {
      setAvailability(null);
    }
  }, []);

  useEffect(() => {
    loadAvailability();
  }, [loadAvailability]);

  return (
    <main className="relative min-h-screen overflow-x-clip bg-[#09090D] text-[#F4F4F6]">
      <div className="noise-overlay" />
      <Navbar availability={availability} />
      <Hero availability={availability} />
      <Marquee />
      <Manifesto />
      <Experience />
      <SocialFeed />
      <NextChapter />
      <RegistrationSection availability={availability} onRegistrationComplete={loadAvailability} />
      <Footer />
    </main>
  );
}
